<template>
  <div id="index">
    <div class="banners">
      <img src="../assets/img/banner.png" alt="" class="banner">
    </div>
    <div class="swipers">
      <swiper :options="swiperOption" ref="bannerSwiper" v-if="swiperImg.length > 0">
        <swiperSlide v-for="(item,index) in swiperImg" :key="index">
          <img class="swiper-slid_img" :src="item.logo" alt=""/>
        </swiperSlide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="navs">
      <div class="nav" v-for="(item, index) in navs" :key="index" @click="goDetail(item.path, index)">
        <img :src="item.bg" alt="" class="icon">
      </div>
    </div>
    <div class="banquans">
      <div class="banquan">
        版权所有 © 2024《新歌来啦》全国海选组委会
      </div>
      <div class="banquan">
        {{ nums }}
      </div>
    </div>
    <van-popup v-model="modalShow" position="center" @close="hideLoginModal">
      <div class="login_modal">
        <div class="titles">
          <div class="title">欢迎登录</div>
          <div class="smart_title">WELCOME TO LOGIN</div>
        </div>
        <div class="form_wrap">
          <div class="wrap_list">
            <img src="../assets/img/icon_acc.jpg" alt="" class="icon">
            <input type="text" class="input" v-model="name" placeholder="请输入姓名">
          </div>
          <div class="wrap_list">
            <img src="../assets/img/icon_pass.jpg" alt="" class="icon">
            <input type="text" class="input" v-model="idcard" placeholder="请输入身份证号码">
          </div>
        </div>
        <div class="btn" @click="login()">立即登录</div>
        <div class="test">仅限已成功报名学员</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import wx from 'weixin-js-sdk';
export default {
  name: "index",
  data() {
    return {
      // 轮播图配置
      swiperOption: {
        notNextTick: true,
        autoplay: 3000,
        loop: true,
        autoplayDisableOnInteraction: false,
        pagination: '.swiper-pagination',
        observer: true,
        observeParents: true,
        onClick: (swiper) => {
          let index = swiper.realIndex;
          if (this.swiperImg[index].linkurl) {
            window.location.href = this.swiperImg[index].linkurl;
          }
        }
      },
      swiperImg: [],
      navs: [
        {
          bg:  require('../assets/img/icon_nav_1_2.png'),
          path: '/baoming'
        },
        {
          bg:  require('../assets/img/icon_nav_2_2.png'),
          path: '/prove'
        },
        {
          bg:  require('../assets/img/icon_nav_3_2.png'),
          path: '/judges?type=0'
        },
        {
          bg:  require('../assets/img/icon_nav_4_2.png'),
          path: '/judges?type=1'
        },
        {
          bg:  require('../assets/img/icon_nav_5_2.png'),
          path: ''
        },
        {
          bg:  require('../assets/img/icon_nav_6_2.png'),
          path: ''
        },
        {
          bg:  require('../assets/img/icon_nav_7_2.png'),
          path: ''
        }
      ],
      nums: '',
      modalShow: false,
      name: '',
      idcard: ''
    };
  },
  computed: {
    swiper() {
      return this.$refs.bannerSwiper.swiper
    }
  },
  mounted() {
    this.getSwiper();
    this.getShareConfig();
  },
  methods: {
    getShareConfig () {
      let link = this.isIos ? this.ios_first_url : location.href.split("#")[0];
      let that = this;
      this.axios.post('/Home/WeAuth/getConfig', {
        url: link
      })
        .then(({data}) => {
          if (data.code === 1) {
            wx.config({
              // debug: true,
              appId: data.data.appId,
              timestamp: data.data.timestamp,
              nonceStr: data.data.nonceStr,
              signature: data.data.signature,
              jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
            });
            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                success: function(res) {
                  let options = {
                    title: '新歌来啦官方通道', // 分享标题
                    desc: '为优秀的歌手提供卫星电视的播出平台，欢迎您的参与！', // 分享描述
                    link: location.origin + '/#/', // 分享链接
                    imgUrl: location.origin + '/logo.png', // 分享图标
                    success: function () {
                    // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                    // 用户取消分享后执行的回调函数
                    }
                  }
                  wx.onMenuShareTimeline(options);
                  wx.onMenuShareAppMessage(options);
                  wx.onMenuShareQQ(options);
                  wx.onMenuShareWeibo(options);
                  wx.onMenuShareQZone(options);
                }
              });
            });
          }
        });
    },
    getSwiper () {
      this.axios.get('/api/Index/getList')
        .then(({data}) => {
          if (data.code === 200) {
            this.swiperImg = data.data;
            this.nums = data.nums;
            if (data.isret == 1) {
              window.location.replace(data.returl);
            }
          }
        });
    },
    bannerLink (url) {
      if (url) {
        window.location.href = url;
      }
    },
    goDetail (path, index) {
      if (index > 3) {
        this.goPath(index - 4);
      } else if (index == 1) {
        this.showLoginModal();
      } else {
        if (!path) return this.Toast('暂未开放');
        this.$router.push(path);
      }
    },
    goPath (index) {
      this.axios.get('/api/Index/getInfo?type=' + index)
        .then(({data}) => {
          if (data.code === 200) {
            if (data.data.linkurl) {
              window.location.href = data.data.linkurl;
            } else if (data.data.logo) {
              this.$router.push('/detail?type=' + index);
            }
          }
        });
    },
    showLoginModal () {
      this.modalShow = true;
    },
    hideLoginModal () {
      this.modalShow = false;
      this.name = '';
      this.idcard = '';
    },
    login () {
      if (!this.name) return this.Toast('请输入姓名');
      if (!this.idcard) return this.Toast('请输入身份证号码');
      this.axios.post('/api/Index/checkLogin', {
        name: this.name,
        id_card: this.idcard
      })
        .then(({data}) => {
          if (data.code === 1) {
            this.$router.push('/success?iscert=' + data.data.iscert);
            localStorage.setItem('shareId', data.data.shareid);
            localStorage.setItem('uuid', data.data.uuid);
          } else {
            this.Toast(data.msg);
          }
        });
    }
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>
<style lang="scss">
@import url('../assets/css/swiper-3.4.0.min.css');
#index {
  .banners{
    width: 100%;
    height:885px;
    .banner{
      width:100%;
      height:100%;
    }
  }
  .swipers{
    width:700px;
    height:360px;
    margin: -280px auto 0;
    border-radius: 28px;
    overflow: hidden;
    .swiper-container{
      width:100%;
      height:100%;
      img{
        width:100%;
        height:100%;
        object-fit: cover;
      }
      .swiper-pagination-bullet{
        width:16px;
        height:16px;
        background-color:#fff;
      }
    }
  }
  .navs{
    margin-top:20px;
    padding: 0 30px;
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .nav{
      width:49.5%;
      height:144px;
      margin-bottom:10px;
      &:nth-child(-n+2){
        height:114px;
      }
      &:last-child{
        margin-right:0;
        width:100%;
        height:114px;
      }
      &:nth-child(2n){
        margin-right:0;
      }
      .icon{
        width:100%;
        height:100%;
      }
    }
  }
  .banquans{
    padding:30px 0;
  }
  .banquan{
    color:#77787c;
    font-size:24px;
    text-align:center;
    line-height:40px;
  }
  .login_modal{
    width:560px;
    background:#fff;
    border-radius: 16px;
    padding: 70px 60px;
    .titles{
      .title{
        text-align: center;
        font-size:36px;
        letter-spacing: 2px;
        font-weight: bold;
        position:relative;
        &:after, &:before{
          width:66px;
          height:1px;
          display:block;
          content:'';
          background:#000;
          position:absolute;
          top:50%;
        }
        &:after{
          right:50px;
        }
        &:before{
          left:50px;
        }
      }
      .smart_title{
        font-size:20px;
        color:#999;
        text-align: center;
        margin-top:10px;
      }
    }
    .form_wrap{
      margin-top:70px;
      .wrap_list{
        width:100%;
        height:80px;
        border:2px solid #999;
        border-radius: 30px;
        padding:0 30px;
        display:flex;
        align-items: center;
        margin-bottom:50px;
        .icon{
          width:40px;
          height:40px;
          margin-right:30px;
        }
        .input{
          width:300px;
          font-size:28px;
        }
      }
    }
    .btn{
      width:100%;
      height:80px;
      border-radius: 25px;
      background:#4480f5;
      margin-top:80px;
      text-align: center;
      font-size:30px;
      color:#fff;
      line-height:80px;
      letter-spacing: 2px;
    }
    .test{
      color:red;
      font-size:26px;
      text-align:center;
      margin-top:30px;
    }
  }
}
</style>
